export const providesList = (resultsWithIds, tagType) => {
  const items = Array.isArray(resultsWithIds)
    ? resultsWithIds
    : resultsWithIds?.data ||
      resultsWithIds?.results ||
      resultsWithIds?.items ||
      [];

  if (Array.isArray(items) && items.length > 0) {
    return [
      ...items.map((item) => ({
        type: tagType,
        id: item?.id || item?._id || item?.record_id,
      })),
      { type: tagType, id: "LIST" },
    ];
  }

  return [{ type: tagType, id: "LIST" }];
};

export const invalidatesList = (tagType) => [{ type: tagType, id: "LIST" }];

export const invalidatesItem = (tagType, id) => [
  { type: tagType, id },
  { type: tagType, id: "LIST" },
];

export const buildQueryParams = (params = {}) => {
  const query = {};
  Object.keys(params).forEach((key) => {
    const val = params[key];
    if (val !== undefined && val !== null && val !== "") {
      query[key] = val;
    }
  });
  return query;
};
